import { authenticatedRequest } from './base.service';

export interface Rate {
  id: string;
  name: string;
  description: string;
  value: number;
  period: 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
  isActive: boolean;
  organization_id: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRateData {
  name: string;
  description: string;
  value: number;
  period: 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
  isActive?: boolean;
}

export interface UpdateRateData {
  name?: string;
  description?: string;
  value?: number;
  period?: 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
  isActive?: boolean;
}

export interface RatesResponse {
  data: Rate[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface RatesQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  period?: 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
}

const getToken = (): string => {
  const token = localStorage.getItem('finara_token');
  if (!token) throw new Error('No authentication token found');
  return token;
};

export const ratesService = {
  async getRates(params?: RatesQueryParams): Promise<RatesResponse> {
    const queryParams = new URLSearchParams();

    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.period) queryParams.append('period', params.period);

    const queryString = queryParams.toString();
    const endpoint = `/api/v1/rates${queryString ? `?${queryString}` : ''}`;

    return authenticatedRequest<RatesResponse>(endpoint, {}, getToken());
  },

  async getRate(id: string): Promise<Rate> {
    return authenticatedRequest<Rate>(`/api/v1/rates/${id}`, {}, getToken());
  },

  async createRate(data: CreateRateData): Promise<Rate> {
    return authenticatedRequest<Rate>(
      '/api/v1/rates',
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      getToken()
    );
  },

  async updateRate(id: string, data: UpdateRateData): Promise<Rate> {
    return authenticatedRequest<Rate>(
      `/api/v1/rates/${id}`,
      {
        method: 'PATCH',
        body: JSON.stringify(data),
      },
      getToken()
    );
  },

  async deleteRate(id: string): Promise<void> {
    return authenticatedRequest<void>(
      `/api/v1/rates/${id}`,
      {
        method: 'DELETE',
      },
      getToken()
    );
  },
};
